var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 132,
    viewBox: "0 0 1440 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00183105 131.5L-0.000604077 56.7418C143.305 38.0583 284.21 -7.26863 427.682 8.35898C497.238 15.9361 562.782 37.576 631.392 49.13C697.494 60.2606 766.328 61.8906 833.209 53.9052C940.836 41.0569 1042.86 3.71532 1151.71 0.269246C1247.43 -2.76251 1345.85 20.3954 1440 21.339L1440 131.5L720.002 131.5L0.00183105 131.5Z",
    fill: "#153D44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoWave);
export default __webpack_public_path__ + "static/media/yo_wave.51b90ccd2a1dfe93b1f563118d089ba4.svg";
export { ForwardRef as ReactComponent };